import type { FarePriceBreakdown, Prices } from "@b2bportal/air-shopping-api";
import type {
  IFareData as CoreIFareData,
  FlightRatingsEnum,
} from "@b2bportal/core-types";

export interface IFareData extends Omit<CoreIFareData, "price"> {
  price: Prices | FarePriceBreakdown;
  /**
   * Grid V2: the carrier surcharges (YQ/YR) this fare's fixed-points price
   * covers, per passenger. From `Fare.fixedPointsEligibilityDetails` (see
   * `gridV2CoveredSurcharges`); absent on V1 and below-minimum fares.
   */
  coveredSurcharges?: Prices;
}

export interface IFlightFares {
  [FlightRatingsEnum.basic]?: IFareData;
  [FlightRatingsEnum.standard]?: IFareData;
  [FlightRatingsEnum.premium]?: IFareData;
  [FlightRatingsEnum.luxury]?: IFareData;
}

export enum TripCategory {
  ONE_WAY = "one_way",
  ROUND_TRIP = "round_trip",
  MULTI_CITY = "multi_city",
}
